<div class="ui basic segment report-page" [class.loading]="isLoading">
    <app-header title="Employee Documents Report" [back]="true" class="report-header">
        <div class="buttons">
            <ui-button type="primary" style="float: right" [matMenu]="exportMenu">
                Export <mat-icon svgIcon="chevronDown"></mat-icon>
            </ui-button>
            <mat-menu #exportMenu="matMenu">
                <button mat-menu-item (click)="onExport('csv')">Export as .csv</button>
                <button mat-menu-item (click)="onExport('xlxs')">Export as .xlxs</button>
            </mat-menu>
        </div>
    </app-header>

    <div *ngIf="report && report.data.sheets && report.data.sheets.length; else emptyState" class="report-body">
        <app-report-table [report]="report" emptyText="There are no documents to report on."></app-report-table>
    </div>

    <ng-template #emptyState>
        <div class="ui segment">
            <app-empty-state label="There are no documents to report on."></app-empty-state>
        </div>
    </ng-template>
</div>
